import { useMutation } from '@apollo/client';
import DELETE_PREREQUISITE_MUTATION from '../mutations/DELETE_PREREQUISITE_MUTATION';

export default function useDeletePrerequisiteMutation() {
    return useMutation( DELETE_PREREQUISITE_MUTATION );
}
